import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-between gap-4 items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, " Permit Info ")
], -1)
const _hoisted_2 = { class: "mt-4 mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-3" }
const _hoisted_3 = { class: "-mx-4 px-4 py-6 shadow-sm ring-1 ring-gray-900/5 sm:mx-0 sm:rounded-lg sm:px-8 lg:col-span-2 lg:row-span-2 lg:row-end-2" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-1/4\"></div></div><dl class=\"mt-6 grid grid-cols-1 text-sm leading-6 sm:grid-cols-2\"><div class=\"sm:pr-4 col-span-1 sm:col-span-2\"><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-1/2\"></div></div><div class=\"mt-6 border-t border-gray-900/5 pt-6 sm:pr-4\"><div><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-1/2\"></div><div class=\"mt-2 h-4 rounded-full bg-gray-300 animate-pulse w-full\"></div><div class=\"mt-1 h-4 rounded-full bg-gray-300 animate-pulse w-3/4\"></div></div></div><div class=\"mt-8 sm:mt-6 sm:border-t sm:border-gray-900/5 sm:pl-4 sm:pt-6\"><div><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-1/2\"></div><div class=\"mt-2 h-4 rounded-full bg-gray-300 animate-pulse w-full\"></div></div></div></dl><div class=\"mt-6 border-t border-gray-900/5 pt-6\"><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-1/4\"></div><div class=\"mt-2 h-4 rounded-full bg-gray-300 animate-pulse w-full\"></div><div class=\"mt-2 h-4 rounded-full bg-gray-300 animate-pulse w-4/5\"></div><div class=\"mt-2 h-4 rounded-full bg-gray-300 animate-pulse w-full\"></div><div class=\"mt-2 h-4 rounded-full bg-gray-300 animate-pulse w-1/3\"></div></div>", 3)
const _hoisted_7 = { class: "text-base font-semibold leading-6 text-gray-900" }
const _hoisted_8 = { class: "mt-6 grid grid-cols-1 text-sm leading-6 sm:grid-cols-2" }
const _hoisted_9 = {
  key: 0,
  class: "sm:pr-4 col-span-1 sm:col-span-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", { class: "inline text-gray-500" }, " Paid on ", -1)
const _hoisted_11 = { class: "inline text-gray-700" }
const _hoisted_12 = {
  key: 1,
  class: "sm:pr-4 col-span-1 sm:col-span-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, " Inspection dates can be requested once the permit fee has been paid in full. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " Please note the online payment option provides the ability to request inspections once the payment has been successfully processed. ", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "mt-6 border-t border-gray-900/5 pt-6 sm:pr-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", { class: "font-semibold text-gray-900" }, " Address ", -1)
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "mt-8 sm:mt-6 sm:border-t sm:border-gray-900/5 sm:pl-4 sm:pt-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dt", { class: "font-semibold text-gray-900" }, " Municipality ", -1)
const _hoisted_21 = { class: "mt-2 text-gray-500" }
const _hoisted_22 = {
  key: 2,
  class: "mt-6 border-t border-gray-900/5 space-y-4 pt-6"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<h2 class=\"text-base font-semibold leading-6 text-gray-900\"> Inspection Requests </h2><p class=\"\"> Now that the permit fee has been paid, you are able to request the next inspection for your permit. Please select a 1st and 2nd choice for the inspection. </p><p class=\"\"><span class=\"font-bold\">Please note this is a request for an inspection only!</span> You will receive an email confirmation once the inspection has been scheduled. </p><div class=\"space-y-2\"><p class=\"font-bold\"> Time Slots </p><p> AM: 7am — 12pm </p><p> PM: 12pm — 4pm </p></div>", 4)
const _hoisted_27 = { class: "text-sm font-bold" }
const _hoisted_28 = { class: "sm:hidden" }
const _hoisted_29 = { class: "text-sm h-full flex items-start" }
const _hoisted_30 = { class: "py-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, " Desired time slot ", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, " Backup time slot ", -1)
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "text-sm h-full flex items-start" }
const _hoisted_36 = { class: "space-y-2 xl:flex xl:items-start xl:justify-start xl:space-y-0 xl:space-x-4 py-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, " Desired time slot ", -1)
const _hoisted_38 = ["value"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, " Backup time slot ", -1)
const _hoisted_40 = ["value"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "pt-4 flex sm:items-center sm:justify-end gap-4 flex-col-reverse sm:flex-row" }
const _hoisted_43 = { class: "lg:col-start-3 lg:row-end-1" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", { class: "sr-only" }, " Summary ", -1)
const _hoisted_45 = { class: "rounded-lg bg-gray-50 shadow-sm ring-1 ring-gray-900/5 py-6" }
const _hoisted_46 = { class: "flex flex-wrap" }
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-auto pl-6\"><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-2/5\"></div><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-3/5 mt-2\"></div></div><div class=\"flex-none px-6\"><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-16\"></div></div><div class=\"mt-6 flex w-full justify-between items-end gap-x-4 border-t border-gray-900/5 px-6 pt-6\"><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-full\"></div></div><div class=\"mt-4 flex w-full justify-between items-end gap-x-4 px-6\"><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-full\"></div></div><div class=\"mt-4 flex w-full justify-between items-end gap-x-4 px-6\"><div class=\"h-4 rounded-full bg-gray-300 animate-pulse w-full\"></div></div>", 5)
const _hoisted_52 = { class: "flex-auto pl-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm font-semibold leading-6 text-gray-900" }, " Total Amount ", -1)
const _hoisted_54 = { class: "mt-1 text-base font-semibold leading-6 text-gray-900" }
const _hoisted_55 = { class: "flex-none px-6" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("dt", { class: "sr-only" }, " Status ", -1)
const _hoisted_57 = { class: "mt-6 flex w-full justify-between items-end gap-x-4 border-t border-gray-900/5 px-6 pt-6" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("dt", { class: "flex-none text-sm" }, " Permit Fee ", -1)
const _hoisted_59 = { class: "text-sm leading-6 text-gray-500" }
const _hoisted_60 = {
  key: 0,
  class: "mt-4 flex w-full justify-between items-end gap-x-4 px-6"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("dt", { class: "flex-none text-sm" }, " State Seal ", -1)
const _hoisted_62 = { class: "text-sm leading-6 text-gray-500" }
const _hoisted_63 = { class: "mt-4 flex w-full justify-between items-end gap-x-4 px-6" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("dt", { class: "flex-none text-sm" }, " Processing Fee (3%) ", -1)
const _hoisted_65 = { class: "text-sm leading-6 text-gray-500" }
const _hoisted_66 = {
  key: 0,
  class: "mt-6 border-t border-gray-900/5 px-6 pt-6"
}
const _hoisted_67 = { class: "lg:col-start-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-semibold leading-6 text-gray-900" }, " Documents ", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mt-2 text-gray-500" }, " Download or upload files related to this permit below ", -1)
const _hoisted_70 = {
  role: "list",
  class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-x-4 gap-y-8 mt-4"
}
const _hoisted_71 = { class: "w-full h-28 overflow-hidden rounded-lg bg-gray-100" }
const _hoisted_72 = { class: "bg-gray-100 w-full h-full pointer-events-none object-cover flex items-center justify-center" }
const _hoisted_73 = { class: "uppercase font-mono font-semibold text-gray-500 border-2 border-gray-400 rounded px-1 py-0.5 max-w-min flex-none text-sm" }
const _hoisted_74 = ["title"]
const _hoisted_75 = { class: "flex items-center justify-between" }
const _hoisted_76 = { class: "pointer-events-none block text-sm font-medium text-gray-500" }
const _hoisted_77 = { class: "mt-6 flex gap-x-3" }
const _hoisted_78 = { class: "p-8 mx-auto" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 block text-sm font-medium text-gray-900" }, " Drop file here or click to choose ", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 space-y-2 my-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Please enter any important notes which would be helpful for the inspector performing the particular inspection."),
  /*#__PURE__*/_createElementVNode("p", null, "This may include items such as door codes or other important information for the permit location.")
], -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", {
  for: "notes",
  class: "block text-base text-gray-900"
}, " Notes ", -1)
const _hoisted_82 = { class: "mt-2 flex relative" }
const _hoisted_83 = { class: "flex items-center justify-start gap-4 mt-6" }
const _hoisted_84 = { class: "text-gray-500 space-y-2 my-4" }
const _hoisted_85 = { class: "flex items-center justify-start gap-4 mt-6" }

import StripePaymentForm from './components/StripePaymentForm.vue'
	import api from '@/utilities/api'
	import axios from 'axios'
	import {
		DocumentArrowUpIcon,
		PencilSquareIcon as PencilSquareIconOutline,
	} from '@heroicons/vue/24/outline'

	import {
		CloudArrowDownIcon,
		ChevronDownIcon,
		TrashIcon
	} from '@heroicons/vue/16/solid'

	import {
		PencilSquareIcon
	} from '@heroicons/vue/24/solid'

	import { 
		Inspection,
		Permit_File,
		PermitRecord,
	} from '@/types'

	import {
		computed,
		onBeforeUnmount,
		onMounted,
		ref
	} from 'vue'
	

	import {
		useRoute
	} from 'vue-router'

	
	const __default__ = { name: 'PermitDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const route = useRoute()
	const query = route.query
	const id = query?.id || ""
	const loading = ref(true)
	const permit = ref<PermitRecord>({} as PermitRecord)

	const isPaid = computed(() => {
		return permit.value.permit?.paymentStatus === "Paid"
	})

	const allInspectionsUnassigned = computed(() => {
		return permit.value.inspections?.every((inspection) => {
			return inspection.status === "Un-assigned"
		})
	})

	
	onMounted(async () => {
		await getPermit()
	})

	onBeforeUnmount(() => {
		drop.value?.removeEventListener("dragover", dragOverFile)
		drop.value?.removeEventListener("drop", dropFile)
		drop.value?.removeEventListener("dragleave", dragLeaveFile)
	})

	/**
    * Fetches data to display on the page
    * @function getPermit
    */
	async function getPermit() {
		try { // loading permit details
			loading.value = true
			
			await checkStatus() // check for successful Stripe payment query params

			let payload = {
				id
			}
	
			const body = {
				action: "getPermit",
				payload: payload,
			}
	
			const response = await api("post", "fmDataApi", "/fm-data-api", body)
			permit.value = JSON.parse(response.response.scriptResult).result.data
			fileDownloadLoading.value = [...Array(permit.value.files)].map(x => false)

			// add drag and drop event listeners
			if(isPaid.value) {
				drop.value?.addEventListener("dragover", dragOverFile)
				drop.value?.addEventListener("drop", dropFile)
				drop.value?.addEventListener("dragleave", dragLeaveFile)
			}
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	}

	function dragOverFile() {
		isOver.value = true
	}

	function dropFile(e: Event) {
		isOver.value = false
		fileUpload(e)
	}

	function dragLeaveFile() {
		isOver.value = false
	}

	
	// #region file operations
	const documentUploadRef = ref<HTMLInputElement | null>()
	const drop = ref<null | HTMLElement>(null)
	const isOver = ref(false)
	const file = ref<File>({} as File)
	const fileInput = ref<File[]>([])
	const fileUploadingLoading = ref(false)

	/**
    * Validates file type, uploads file to S3 and creates record in FileMaker
    * @function fileUpload
    * @param {Object} e - drop event
    */
	async function fileUpload(e: any){
		try {
			fileUploadingLoading.value = true
			isOver.value = false
			fileInput.value = e.target.files || e.dataTransfer.files
			file.value = fileInput.value?.['0']
			const re = new RegExp(/^.+\.(jpg|jpeg|gif|png|pdf)$/, 'g')
			const acceptedFileType = re.test(file.value.name.toLowerCase())
			if(!acceptedFileType){
				alert("Unaccepted file type")
				throw("Unaccepted file type")
			}

			// get signed upload url
			let getPayload = {
				type: "permit",
				entityId: permit.value.permit.id,
				filename: file.value.name,
				size: file.value.size,
				mimeType: file.value.type
			}

			const getBody = {
				action: "uploadFile",
				payload: getPayload,
			}

			const getResponse = await api("post", "fmDataApi", "/fm-data-api", getBody)
			const getScriptResult = JSON.parse(getResponse.response.scriptResult)

			// upload file to s3
			const signedUrl = getScriptResult.signedRequest
			const config = {
				method: 'put',
				url: signedUrl,
				data: file.value
			}
			const res = await axios(config)
			
			// mark file as uploaded
			const patchPayload = {
				type: "permit",
				fileId: getScriptResult.uuid
			}

			const patchBody = {
				action: "confirmUpload",
				payload: patchPayload,
			}

			const patchResponse = await api("post", "fmDataApi", "/fm-data-api", patchBody)
			const patchScriptResult = JSON.parse(patchResponse.response.scriptResult)
			if(patchScriptResult.success) {
				notificationType.value = 0
				notificationTitle.value = "Success"
				notificationSubtitle.value = "File uploaded complete."
				showNotification.value = true
				drop.value?.removeEventListener("dragover", dragOverFile)
				drop.value?.removeEventListener("drop", dropFile)
				drop.value?.removeEventListener("dragleave", dragLeaveFile)
				getPermit()
			}
			else {
				notificationType.value = 1
				notificationTitle.value = "Error"
				notificationSubtitle.value = "There was an issue uploading your file. Please try again."
				showNotification.value = true
			}

		}
		catch(err) {
			console.log(err)
			notificationType.value = 1
			notificationTitle.value = "Error"
			notificationSubtitle.value = "There was an issue uploading your file. Please try again."
			showNotification.value = true
		}
		finally {
			fileUploadingLoading.value = false
		}
	}

	const fileDownloadLoading = ref<boolean[]>([])

	/**
    * Downloads file from S3
    * @function downloadFile
	* @param {Permit_File} file - the file object to download
	* @param {Number} index - the index of the file in the list of files
    */
	async function downloadFile(file: Permit_File, index: number) {
		
		let payload = {
			fileId: file.fileID
		}
	
		const body = {
			action: "getSignedUrl",
			payload: payload,
		}
		try {
			fileDownloadLoading.value[index] = true
			const response = await api("post", "fmDataApi", "/fm-data-api", body)
			const signedUrl = JSON.parse(response.response.scriptResult).downloadURL
	
			const link = document.createElement("a")
			link.href = signedUrl
			link.target = "_blank"
			link.download = file.fileName
			link.click()
		}
		catch(e) {
			console.error(e)
		}
		finally {
			fileDownloadLoading.value[index] = false
		}
	}

	const deleteModal = ref<{open: boolean}>({open: false})
	const selectedFile = ref<Permit_File>({} as Permit_File)
	const deleteLoading = ref(false)

	/**
    * Opens delete file confirmation modal
    * @function openDeleteModal
	* @param {Permit_File} file - the file object to delete
    */
	function openDeleteModal(file: Permit_File) {
		selectedFile.value = file
		deleteModal.value.open = true
	}

	/**
    * Closes the delete file confirmation modal and optionally deletes the file from S3 and FileMaker
    * @function closeDeleteModal
	* @param {Boolean} deleteFile - whether or not to delete the selected file when closing the modal
    */
	async function closeDeleteModal(deleteFile: boolean = false) {
		if(deleteFile) {
			const payload = {
				fileId: selectedFile.value.fileID
			}
		
			// save note
			const body = {
				action: "deleteFile",
				payload: payload
			}

			try {
				deleteLoading.value = true
				const response = await api("post", "fmDataApi", "/fm-data-api", body)
				const scriptResult = JSON.parse(response.response.scriptResult)
				if(scriptResult.success) {
					notificationType.value = 0
					notificationTitle.value = "Success"
					notificationSubtitle.value = "File deleted."
					showNotification.value = true
					getPermit()
				}
				else {
					notificationType.value = 1
					notificationTitle.value = "Error"
					notificationSubtitle.value = "There was an issue deleting your file. Please try again."
					showNotification.value = true
				}
			}
			catch(e) {
				console.error(e)
				notificationType.value = 1
				notificationTitle.value = "Error"
				notificationSubtitle.value = "There was an issue deleting your file. Please try again."
				showNotification.value = true
			}
			finally {
				deleteLoading.value = false
			}
		}
		deleteModal.value.open = false

	}
	// #endregion


	// #region notes modal
	const notesModal = ref<{open: boolean}>({open: false})
	const selectedInspection = ref<Inspection>({} as Inspection)
	const notesTemp = ref("")
	const notesLoading = ref(false)

	/**
    * Opens inspection requests notes modal
    * @function openNotesModal
	* @param {Inspection} inspection - the inspection object to edit
    */
	function openNotesModal(inspection: Inspection) {
		selectedInspection.value = inspection
		notesTemp.value = inspection.note
		notesModal.value.open = true
	}

	/**
    * Closes the inspection requests notes modal and optionally saves the changes
    * @function closeNotesModal
	* @param {Boolean} save - whether or not to save the changes to FileMaker
    */
	async function closeNotesModal(save: boolean = false) {
		if(save) {
			selectedInspection.value.note = notesTemp.value
			let payload = {
				inspectionId: selectedInspection.value.id,
				notes: notesTemp.value
			}	
		
			// save note
			const body = {
				action: "saveInspectionNotes",
				payload: payload
			}

			try {
				notesLoading.value = true
				const {response} = await api("post", "fmDataApi", "/fm-data-api", body)
				const scriptResult = JSON.parse(response?.scriptResult ?? "{}")
				const code = scriptResult?.messages?.code
				if(code == 301) {
					notificationType.value = 1
					notificationTitle.value = "Error"
					notificationSubtitle.value = "Unable to save note. Please try again later."
					showNotification.value = true
					return
				}
			}
			catch(e) {
				console.error(e)
			}
			finally {
				notesLoading.value = false
			}
		}

		notesTemp.value = ""
		notesModal.value.open = false
	}
	// #endregion


	// #region submit inspection requests
	const submitRequestLoading = ref(false)
	const showNotification = ref<boolean>(false)
	const notificationTitle =  ref<string | null>(null)
	const notificationSubtitle =  ref<string | null>(null)
	const notificationType =  ref<number | null>(null)

	const allTimeSlotsEmpty = computed(() => {
		return permit.value.inspections?.every((inspection) => {
			return !inspection.timeSlot1 && !inspection.timeSlot2
		})
	})

	const timeSlotHasError = computed(() => {
		return permit.value.inspections?.some((inspection) => {
			return inspection.timeSlot2 !== '' && inspection.timeSlot1 === inspection.timeSlot2
		})
	})

	/**
    * Submits the selected inspection requests time slots and saves changes to FileMaker
    * @function submitInspectionRequest
	* @param {Boolean} cancel - whether or not to cancel the selected time slots
    */
	async function submitInspectionRequest(cancel: boolean = false) {
		if(allTimeSlotsEmpty.value) {
			notificationTitle.value = "Error"
			notificationSubtitle.value = "Please select desired and backup time slots for all inspections"
			showNotification.value = true
			return
		}

		if(timeSlotHasError.value) {
			notificationTitle.value = "Error"
			notificationSubtitle.value = "Desired and backup time slots must be different"
			showNotification.value = true
			return
		}

		let payload = {
			inspections: permit.value.inspections
		}
		if(cancel) {
			payload.inspections = permit.value.inspections.map((inspection) => {
				return {...inspection, timeSlot1: '', timeSlot2: ''}
			})
		}
	
		const body = {
			action: "submitInspectionRequest",
			payload: payload,
		}
		try {
			submitRequestLoading.value = true
			await api("post", "fmDataApi", "/fm-data-api", body)

			notificationType.value = 0
			notificationTitle.value = "Success"
			notificationSubtitle.value = "Inspection request recieved"
			showNotification.value = true
			
		}
		catch(e) {
			console.error(e)
		}
		finally {
			submitRequestLoading.value = false
			await getPermit()
		}
	}

	// #region payment modal
	const paymentModal = ref<{open: boolean}>({open: false})
	
	/**
    * Opens payment modal
    * @function openPaymentModal
    */
	function openPaymentModal() {
		paymentModal.value.open = true
	}

	const stripeForm = ref<{clientSecret: string}>({clientSecret: ""})

	/**
	* Runs when the payment modal is closed and cancels payment intent
	* @function closePaymentModal
	*/
	async function closePaymentModal(completePayment: boolean = false) {
		const { paymentIntent } = await stripe.retrievePaymentIntent(stripeForm.value.clientSecret)
		const body = {
			paymentIntentId: paymentIntent.id
		}
		const response = await api("post", "fmDataApi", "/cancel-payment-intent", body)
	}

	// eslint-disable-next-line
	const stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY)

	// Fetches the payment intent status after payment submission
	async function checkStatus() {
		const urlParams = new URLSearchParams(window.location.search)
		const clientSecret = urlParams.get(
			"payment_intent_client_secret"
		)
	
		if (!clientSecret) {
			return
		}

		const query = route.query
		window.history.replaceState({}, document.title, "/permitdetail?id=" + query.id)

		const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret)
		
		switch (paymentIntent.status) {
			case "succeeded":
				showMessage("Payment succeeded!", 0)
				await updatePaymentStatusInFM(paymentIntent)
				break
			case "processing":
				showMessage("Your payment is processing.", 0)
				await updatePaymentStatusInFM(paymentIntent)
				break
			case "requires_payment_method":
				showMessage("Your payment was not successful, please try again.", 1)
				break
			default:
				showMessage("Something went wrong.", 1)
				break
		}
	}

	async function updatePaymentStatusInFM(paymentIntent:any) {
		let payload = {
			id,
			paymentIntent
		}	
		
		const body = {
			action: "completeStripe",
			payload: payload
		}

		try {
			await api("post", "fmDataApi", "/fm-data-api", body)
		}
		catch(e) {
			console.error(e)
		}
	}

	function showMessage(message: string, isError: number) {
		notificationType.value = isError
		notificationTitle.value = isError ? "Error" : "Success"
		notificationSubtitle.value = message
		showNotification.value = true
	}
	// #endregion

return (_ctx: any,_cache: any) => {
  const _component_tw_notification = _resolveComponent("tw-notification")!
  const _component_v_legend = _resolveComponent("v-legend")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_error_message = _resolveComponent("v-error-message")!
  const _component_v_fieldset = _resolveComponent("v-fieldset")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_tw_loading = _resolveComponent("tw-loading")!
  const _component_v_dropdown_button = _resolveComponent("v-dropdown-button")!
  const _component_v_dropdown_label = _resolveComponent("v-dropdown-label")!
  const _component_v_dropdown_item = _resolveComponent("v-dropdown-item")!
  const _component_v_dropdown_divider = _resolveComponent("v-dropdown-divider")!
  const _component_v_dropdown_menu = _resolveComponent("v-dropdown-menu")!
  const _component_v_dropdown = _resolveComponent("v-dropdown")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showNotification.value)
      ? (_openBlock(), _createBlock(_component_tw_notification, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showNotification.value = false)),
          icon: notificationType.value,
          title: notificationTitle.value ?? 'Notification',
          subtitle: notificationSubtitle.value ?? 'Message'
        }, null, 8, ["icon", "title", "subtitle"]))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (loading.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_4
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("h2", _hoisted_7, " Permit #" + _toDisplayString(permit.value?.permit?.permitNumber), 1),
                _createElementVNode("dl", _hoisted_8, [
                  (_unref(isPaid))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(' ') + " "),
                        _createElementVNode("dd", _hoisted_11, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$filters.friendlyDate(permit.value?.permit?.datePaid)), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15)),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, [
                      _hoisted_17,
                      _createElementVNode("dd", {
                        class: "mt-2 text-gray-500",
                        innerHTML: permit.value?.permit?.addressSingleLine.replace(', ', '<br> ') || '—'
                      }, null, 8, _hoisted_18)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      _createElementVNode("dd", _hoisted_21, _toDisplayString(permit.value?.permit?.municipalityName || "—"), 1)
                    ])
                  ])
                ])
              ], 64)),
          (_unref(isPaid))
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_tw_table, {
                  data: permit.value.inspections
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_tw_table_column, {
                      header: "Type",
                      prop: "type",
                      "class-name": "w-40",
                      "header-class-name": "w-40"
                    }, {
                      default: _withCtx(({row}) => [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(row.type), 1),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(row.status), 1),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_v_fieldset, { class: "space-y-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_legend, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Request Inspection Time")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_field, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      modelValue: row.timeSlot1,
                                      "onUpdate:modelValue": ($event: any) => ((row.timeSlot1) = $event)
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_31,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permit.value.timeSlots, (option) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: option.id,
                                            value: option.timeSlot
                                          }, _toDisplayString(option.timeSlot), 9, _hoisted_32))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_field, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      modelValue: row.timeSlot2,
                                      "onUpdate:modelValue": ($event: any) => ((row.timeSlot2) = $event),
                                      invalid: row.timeSlot2 !== '' && row.timeSlot1 === row.timeSlot2
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_33,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permit.value.timeSlots, (option) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: option.id,
                                            value: option.timeSlot
                                          }, _toDisplayString(option.timeSlot), 9, _hoisted_34))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "invalid"]),
                                    (row.timeSlot2 !== '' && row.timeSlot1 === row.timeSlot2)
                                      ? (_openBlock(), _createBlock(_component_v_error_message, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Times must be different ")
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_tw_table_column, {
                      header: "Status",
                      prop: "status",
                      "class-name": "w-28 hidden sm:table-cell",
                      "header-class-name": "w-28 hidden sm:table-cell"
                    }, {
                      default: _withCtx(({row}) => [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(row.status), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_tw_table_column, {
                      "class-name": "flex items-start w-full hidden sm:table-cell",
                      "header-class-name": "w-full hidden sm:table-cell",
                      header: "Request Inspection Time"
                    }, {
                      default: _withCtx(({row}) => [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_v_field, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: row.timeSlot1,
                                "onUpdate:modelValue": ($event: any) => ((row.timeSlot1) = $event)
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permit.value.timeSlots, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.id,
                                      value: option.timeSlot
                                    }, _toDisplayString(option.timeSlot), 9, _hoisted_38))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_field, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: row.timeSlot2,
                                "onUpdate:modelValue": ($event: any) => ((row.timeSlot2) = $event),
                                invalid: row.timeSlot2 !== '' && row.timeSlot1 === row.timeSlot2
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_39,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permit.value.timeSlots, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.id,
                                      value: option.timeSlot
                                    }, _toDisplayString(option.timeSlot), 9, _hoisted_40))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "invalid"]),
                              (row.timeSlot2 !== '' && row.timeSlot1 === row.timeSlot2)
                                ? (_openBlock(), _createBlock(_component_v_error_message, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Times must be different ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_tw_table_column, {
                      header: "Notes",
                      align: "center",
                      "class-name": "w-16",
                      "header-class-name": "w-16"
                    }, {
                      default: _withCtx(({row}) => [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openNotesModal(row))
                        }, [
                          (row.note)
                            ? (_openBlock(), _createBlock(_unref(PencilSquareIcon), {
                                key: 0,
                                class: "text-black h-6 w-6 hover:text-gray-300"
                              }))
                            : (_openBlock(), _createBlock(_unref(PencilSquareIconOutline), {
                                key: 1,
                                class: "text-gray-400 h-6 w-6 hover:text-gray-300"
                              }))
                        ], 8, _hoisted_41)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createElementVNode("div", _hoisted_42, [
                  (!_unref(allInspectionsUnassigned))
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 0,
                        class: "w-full sm:w-56",
                        color: "white",
                        disabled: submitRequestLoading.value,
                        loading: submitRequestLoading.value,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (submitInspectionRequest(true)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Cancel Inspection Request ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_button, {
                    class: "w-full sm:w-56",
                    color: "amber",
                    disabled: submitRequestLoading.value,
                    loading: submitRequestLoading.value,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (submitInspectionRequest(false)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Submit Inspection Request ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("dl", _hoisted_46, [
              (loading.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_47
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("dd", _hoisted_54, _toDisplayString(_ctx.$filters.usd(permit.value?.permit?.feeTotal) || "—"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("dd", null, [
                        _createVNode(_component_v_badge, {
                          color: _unref(isPaid) ? 'green' : 'red' 
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(permit.value?.permit?.paymentStatus || "No status"), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("dd", _hoisted_59, _toDisplayString(_ctx.$filters.usd(permit.value?.permit?.feePermit) || "—"), 1)
                    ]),
                    (permit.value?.permit?.feeStateSeal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("dd", _hoisted_62, _toDisplayString(_ctx.$filters.usd(permit.value?.permit?.feeStateSeal) || "—"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("dd", _hoisted_65, _toDisplayString(_ctx.$filters.usd(permit.value?.permit?.feeProcessing) || "—"), 1)
                    ])
                  ], 64))
            ]),
            (!_unref(isPaid) && !loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _createVNode(_component_v_button, {
                    class: "w-full sm:w-auto lg:w-full mx-auto",
                    color: "amber",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (openPaymentModal()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Pay Permit Fee ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_67, [
          _hoisted_68,
          _hoisted_69,
          _createElementVNode("ul", _hoisted_70, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permit.value.files, (file, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: file.fileName,
                class: _normalizeClass(["relative", {'opacity-50': fileDownloadLoading.value[i]}])
              }, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, _toDisplayString(file.fileName.split('.')[file.fileName.split('.').length - 1]), 1)
                  ])
                ]),
                _withDirectives(_createVNode(_component_tw_loading, { class: "absolute -top-6 w-full" }, null, 512), [
                  [_vShow, fileDownloadLoading.value[i]]
                ]),
                _createElementVNode("p", {
                  class: "pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900",
                  title: file.fileName
                }, _toDisplayString(file.fileName), 9, _hoisted_74),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("p", _hoisted_76, _toDisplayString(file.created.split(' ')[0]), 1)
                ]),
                _createVNode(_component_v_dropdown, { class: "mt-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_dropdown_button, {
                      color: "light",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" File Actions "),
                        _createVNode(_unref(ChevronDownIcon))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_dropdown_menu, { anchor: "top" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_dropdown_item, {
                          onClick: ($event: any) => (downloadFile(file, i))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CloudArrowDownIcon)),
                            _createVNode(_component_v_dropdown_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Download")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (file.isAllowedDelete)
                          ? (_openBlock(), _createBlock(_component_v_dropdown_divider, { key: 0 }))
                          : _createCommentVNode("", true),
                        (file.isAllowedDelete)
                          ? (_openBlock(), _createBlock(_component_v_dropdown_item, {
                              key: 1,
                              onClick: ($event: any) => (openDeleteModal(file))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(TrashIcon)),
                                _createVNode(_component_v_dropdown_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Delete")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", {
              class: "stealthFileContainer fileContainer w-full",
              ref_key: "drop",
              ref: drop,
              onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
              onDrop: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("label", {
                for: "FileUpload",
                class: _normalizeClass([{'border-solid' : !file.value, 'border-dashed' : file.value}, "w-auto flex-none fileContainer relative border-2 border-gray-300 rounded-sm text-center hover:border-gray-400 cursor-pointer box-content flex justify-start align-middle"])
              }, [
                _createElementVNode("div", _hoisted_78, [
                  _createVNode(_unref(DocumentArrowUpIcon), {
                    "aria-hidden": "true",
                    class: "mx-auto h-6 w-6 text-gray-500"
                  }),
                  _hoisted_79
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["h-full w-full absolute top-0 left-0 text-white text-3xl p-8", {'bg-gray-400 opacity-100 bg-opacity-90 rounded-sm z-20': isOver.value, 'z-0  opacity-0 ': !isOver.value}])
                }, " Drop to upload file ", 2),
                _createElementVNode("input", {
                  type: "file",
                  id: "FileUpload",
                  name: "upload",
                  accept: ".jpg, .gif, .png, .pdf",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (fileUpload($event))),
                  class: "hidden h-44 w-44",
                  ref_key: "documentUploadRef",
                  ref: documentUploadRef
                }, null, 544)
              ], 2)
            ], 544)
          ])
        ], 512), [
          [_vShow, _unref(isPaid)]
        ])
      ])
    ]),
    _createVNode(_component_tw_modal, {
      title: "Inspection Notes",
      "modal-max-width": "max-w-lg",
      ref_key: "notesModal",
      ref: notesModal
    }, {
      default: _withCtx(() => [
        _hoisted_80,
        _hoisted_81,
        _createElementVNode("div", _hoisted_82, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((notesTemp).value = $event)),
            id: "notes",
            class: "flex-1 min-w-0 block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-offset-1 ring-1 ring-gray-300 placeholder:text-gray-500 focus:ring-2 focus:ring-yellow-500 sm:text-sm dark:bg-white/5 dark:text-white dark:ring-white/10 dark:focus:ring-indigo-500",
            rows: "6"
          }, null, 512), [
            [_vModelText, notesTemp.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_83, [
          _createVNode(_component_v_button, {
            class: "w-full sm:w-56",
            color: "white",
            disabled: notesLoading.value,
            loading: notesLoading.value,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (closeNotesModal(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_v_button, {
            class: "w-full sm:w-56",
            color: "amber",
            disabled: notesLoading.value,
            loading: notesLoading.value,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (closeNotesModal(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Save ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_tw_modal, {
      title: "Delete FIle",
      "modal-max-width": "max-w-lg",
      ref_key: "deleteModal",
      ref: deleteModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("p", null, "Permantly delete " + _toDisplayString(selectedFile.value.fileName) + "? There is no undoing this action.", 1)
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createVNode(_component_v_button, {
            class: "w-full sm:w-56",
            color: "white",
            disabled: deleteLoading.value,
            loading: deleteLoading.value,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (closeDeleteModal(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_v_button, {
            class: "w-full sm:w-56",
            color: "amber",
            disabled: deleteLoading.value,
            loading: deleteLoading.value,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (closeDeleteModal(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Delete ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_tw_modal, {
      "block-overlay-close": "",
      onClose: _cache[12] || (_cache[12] = ($event: any) => (closePaymentModal())),
      title: "Pay Permit",
      "modal-max-width": "sm:max-w-sm",
      ref_key: "paymentModal",
      ref: paymentModal
    }, {
      default: _withCtx(() => [
        _createVNode(StripePaymentForm, {
          ref_key: "stripeForm",
          ref: stripeForm,
          permit: permit.value
        }, null, 8, ["permit"])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})